import React, { useEffect } from 'react'
import { H3 } from '../../../../../../_components/Typography/Components/Headings/H3'
import { Box } from '../../../../../../components/Box/Box'
import { Grid, GridCol } from '../../../../../../components/Grid'
import { Button } from '../../../../../../_components/Button'
import { SignatureDocumentStatus } from './SignatureDocumentStatus'
import { getSignatureRequestsStatuses } from '../../../../../../_services/v2/documents.service'
import { RenderIf } from '../../../../../../components/helpers/RenderIf/RenderIf'
import download from 'downloadjs'
import request from '../../../../../../_services/axios_service'

export const RequestSignaturesProcess = ({ schedule, createdDocs }) => {
  const [signatureRequestsStatuses, setSignatureRequestsStatuses] = React.useState([])
  useEffect(() => {
    const fetchData = async () => {
      const response = await getSignatureRequestsStatuses(schedule.id)
      setSignatureRequestsStatuses(response)
    }
    fetchData()
  }, [createdDocs])

  const downloadDocument = (url) => {
    request({
      url: url,
      method: 'GET',
      responseType: 'arraybuffer',
    }).then((resp) => {
      download(resp, 'signed_document.pdf')
    })
    return true
  }

  return (
    <RenderIf condition={signatureRequestsStatuses.length > 0}>
      <Box mt={'20px'}>
        <H3 fw={400} mb={'15px'}>
          Signature Process
        </H3>
        <Box borderRadius={'3px'} borderWidth={'1px'} p={'20px'}>
          <Grid columns={3}>
            {signatureRequestsStatuses.map((status, index) => (
              <GridCol key={index} style={{ marginBottom: '40px' }} xs={1}>
                <SignatureDocumentStatus
                  documentName={status.template}
                  id={status.id}
                  key={index}
                  signers={status.signers}
                  state={status.state}
                />
                <RenderIf condition={status.state === 'completed'}>
                  <Button
                    className="link"
                    onClick={() => downloadDocument(status.document_url)}
                    style={{ fontSize: '13px' }}
                    type="link"
                  >
                    download signed document
                  </Button>
                </RenderIf>
              </GridCol>
            ))}
          </Grid>
        </Box>
      </Box>
    </RenderIf>
  )
}
